<template>
  <NonScDrawer
    :open="
      drawer.open
    "
    @closed="
      () => drawer.open = false
    ">
    <template v-slot:body>
      <div
        class="
          drawer-body
        ">
        <div
          class="
            editor-header
          ">
          <h4
            class="
              editor-title
            ">
            {{ title }}
          </h4>
        </div>
        <div class="editor-form">
          <div>
            <label>
              <i v-if="valid.structure"
                class="
                  el-icon-circle-check valid
                "
              />
              <i v-else
                class="
                  el-icon-warning invalid
                "
              /> ประเภทสิ่งก่อสร้าง
            </label>
            <br/>
            <div class="group">
              <el-button
                v-for="
                  (option, i) in construct
                "
                :key="i"
                :type="
                  'sc-asset'
                "
                :inactive="
                  input.structure != option.name
                "
                @click="
                  () => input.structure = option.name
                ">
                {{ option.name }}
              </el-button>
            </div>
          </div>

          <div class="form grid-2">
            <div>
              <label>
                <i v-if="valid.addressNo"
                  class="
                    el-icon-circle-check valid
                  "
                />
                <i v-else
                  class="
                    el-icon-warning invalid
                  "
                /> เลขที่
              </label>
              <input
                type="text"
                name="addressNo"
                :disabled="
                  mode == 'update'
                "
                v-model="
                  input.addressNo
                "
                class="
                  input el-input__inner
                "
                :placeholder="
                  'ระบุเลขที่อยู่ 99, 1/99, หรือ 1/9-9'
                "
              />
            </div>

            <div>
              <label> ถนน </label>
              <input
                type="text"
                name="addressRoad"
                v-model="
                  input.addressRoad
                "
                class="
                  input el-input__inner
                "
                :placeholder="
                  'ระบุถนน'
                "
              />
            </div>
          </div>

          <div class="form grid-2">
            <div>
              <label>
                พื้นที่ใช้สอย (ตร.ม.)
              </label>
              <input
                type="number"
                name="area"
                v-model="
                  input.area
                "
                class="
                  input el-input__inner
                "
                :placeholder="
                  'ระบุตัวเลข 1 - 2000 (ตร.ม.)'
                "
              />
            </div>
            <div>
              <label>
                <i v-if="valid.transferDate"
                  class="
                    el-icon-circle-check valid
                  "
                />
                <i v-else
                  class="
                    el-icon-warning invalid
                  "
                /> วันที่โอน
              </label>
              <input
                type="date"
                name="transferDate"
                v-model="
                  input.transferDate
                "
                class="
                  input el-input__inner
                "
              />
            </div>
          </div>

          <div>
            <label>
              <i v-if="valid.address"
                class="
                  el-icon-circle-check valid
                "
              />
              <i v-else
                class="
                  el-icon-warning invalid
                "
              /> รายละเอียดที่อยู่
            </label>
            <NonScAddress
              :selected="
                input
              "
              :open="
                address.open
              "
              @selected="
                value => setAddress(value)
              "
            />
          </div>

          <div
            class="
              editor-action group
            ">
            <el-button
              class="action"
              type="sc-asset"
              :disabled="
                !allow
              "
              @click="
                () => submit()
              ">
              บันทึก
            </el-button>
            <el-button
              v-if="
                mode == 'update'
              "
              class="action"
              type="danger"
              @click="
                () => remove()
              ">
              ลบบ้าน
            </el-button>
            <el-button
              class="action"
              type="info"
              @click="
                () => drawer.open = false
              ">
              ยกเลิก
            </el-button>
          </div>
        </div>
      </div>
    </template>
  </NonScDrawer>
</template>

<script lang="js">

// Common
import {
  NonScCommon as Common
} from '../../common/nonsc.common'

import {
  NonScHomeCommon as HomeCommon
} from '../../common/nonsc-home.common'

// Components
import NonScAddress from '../../components/NonScAddress.vue'
import NonScDrawer from '../../components/NonScDrawer.vue'

// Utils
import {
  ValidateUtility as Validate
} from '../../utils/validate'

export default {
  components: {
    NonScAddress,
    NonScDrawer,
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'create'
    },
    form: {
      type: Object,
      default: () => HomeCommon.input
    }
  },
  data() {
    return {
      drawer: {
        open: false
      },
      address: {
        open: false
      },
      input: Object.assign(
        {}, HomeCommon.input
      )
    }
  },
  watch: {
    open(value) {

      // Validate State
      if (!value) return
      
      // Set Drawer
      this.drawer.open = value

      // Set Input
      if (value) {
        this.input = (
          Object.assign({}, this.form)
        )
      }
      else {
        setTimeout(this.reset, 400)
      }
    },
    'drawer.open'(open) {
      if (!open) this.$emit('closed')
    },
  },
  computed: {
    title() {
      return (
        this.mode == 'create'
          ? 'เพิ่มข้อมูลบ้าน'
          : 'แก้ไขข้อมูลบ้าน'
      )
    },
    construct() {
      return Common.construct
    },
    role() {
      return Common.role
    },
    valid() {

      // Validator
      const valid = {
        addressNo     : false,
        address       : false,
        structure     : false,
        transferDate  : false,
      }

      // Validate Input
      if (!this.input) return valid

      // Email Input
      const {
        addressNo,
        structure,
        transferDate,
      } = this.input

      // Validate Address Number
      valid.addressNo = (
        Validate.isAddrNo(addressNo)
      )
      
      // Validate Address
      valid.address = (
        Validate.isLocation(this.input)
      )
      
      // Validate Construction type
      valid.structure = this.construct.some(
        e => e.name == structure
      )

      // Validate Transfer Date
      valid.transferDate = (
        !!transferDate && Validate.isDate(transferDate)
      )

      return valid
    },
    allow() {
      return Object.values(this.valid).every(e => e)
    }
  },
  mounted() {
    
    // Set Drawer
    this.drawer.open = this.open
    
    // Set Input
    this.input = Object.assign(
      {}, HomeCommon.input, this.form
    )
  },
  methods: {
    reset() {
      this.input = Object.assign(
        {}, HomeCommon.input
      )
    },
    setAddress(input) {

      // Set Location
      const location = (
        Common.setLocation(input)
      )
      
      // Validate Input
      if (location) {
        Object.assign(this.input, location)
      }
    },
    submit() {
      
      // Emit Change
      this.$emit(
        'submit', this.input
      )
      
      // Set Drawer
      this.drawer.open = false
    },
    remove() {

      // Emit Remove
      this.$emit(
        'remove', this.input.id
      )
      
      // Set Drawer
      this.drawer.open = false
    },
  }
}
</script>

<style lang="css" scoped>

.drawer-body {
  display         : flex;
  flex-direction  : column;
  height          : 100svh;
}

.editor-header {
  padding: var(--size-lg);
}

.editor-title {
  margin: 0;
}

.editor-form {
  flex            : 1;
  display         : flex;
  flex-direction  : column;
  gap             : var(--size-sm);
  padding         : var(--size-lg);
  padding-top     : 0;
  overflow-x      : hidden;
  overflow-y      : auto;
}

.editor-action {
  display     : flex;
  margin-top  : var(--size-xs);
}

.group {
  display   : flex;
  gap       : var(--size-xs);
  flex-wrap : wrap;
}

.editor-action.group {
  gap: var(--size-md);
}

.el-button.action {
  min-width: 5rem;
}

@media screen and (max-width: 768px) {

  .editor-header {
    padding: var(--size-md);
  }

  .editor-form {
    padding: 0 var(--size-md);
  }

  .editor-title {
    text-align: right;
  }
}

</style>


// WEBPACK FOOTER //
// src/features/nonsc/pages/home/NonScHomeEditor.vue